import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=06b78ec2&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06b78ec2')) {
      api.createRecord('06b78ec2', component.options)
    } else {
      api.reload('06b78ec2', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=06b78ec2&", function () {
      api.rerender('06b78ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nQuYF99ZiKh4/JS/ImageCarousel.vue"
export default component.exports